/**
 * Pure functions to build API-shaped config from step state.
 * Used by step components to report a single config object to the parent.
 */

export function buildSortConfig(state) {
  if (!state?.enabled) return null;
  const { method, sortField1, sortDirection1, sortField2, sortDirection2, linearPairs, mixRows } = state;
  if (method === 'sort') {
    const fields = [sortField1].filter(Boolean);
    if (sortField2) fields.push(sortField2);
    if (fields.length === 0) return null;
    const directions = fields.length === 1 ? [sortDirection1] : [sortDirection1, sortDirection2];
    return { method: 'sort', params: { fields, direction: directions } };
  }
  if (method === 'linear') {
    if (!linearPairs?.length) return null;
    return { method: 'linear', params: linearPairs.map(({ field, weight }) => ({ field, weight })) };
  }
  if (method === 'mix') {
    if (!mixRows?.length) return null;
    return {
      method: 'mix',
      params: mixRows.map(({ field, direction, percentage }) => ({ field, direction, percentage })),
    };
  }
  return null;
}

export function buildDiversityConfig(state) {
  if (!state?.enabled) return null;
  const { method, diversityFields, semanticLambda, semanticHorizon } = state;
  if (method === 'fields') {
    if (!diversityFields?.length) return null;
    return { method: 'fields', params: { fields: [...diversityFields] } };
  }
  if (method === 'semantic') {
    return {
      method: 'semantic',
      params: { lambda: Number(semanticLambda), horizon: Number(semanticHorizon) },
    };
  }
  return null;
}

export function buildLimitsByFieldConfig(state) {
  if (!state?.enabled || !state?.pairs?.length) return null;
  const everyN = Number(state.everyN);
  if (!Number.isInteger(everyN) || everyN < 2) return null;
  return {
    every_n: everyN,
    rules: state.pairs.map(({ field, limit }) => ({ field, limit: Number(limit) || 0 })),
  };
}
